import React from 'react';
import '../styles/toolbar.css';

const tools = [
  { id: 'select', icon: '🖱️', label: 'Seleccionar' },
  { id: 'rectangle', icon: '⬜', label: 'Rectángulo' },
  { id: 'circle', icon: '⚪', label: 'Círculo' },
  { id: 'text', icon: '🔤', label: 'Texto' },
  { id: 'connector', icon: '↔️', label: 'Conector' },
];

const Toolbar = ({ selectedTool, onToolSelect }) => {
  return (
    <div className="toolbar">
      {tools.map(tool => (
        <button
          key={tool.id}
          className={`tool-btn ${selectedTool === tool.id ? 'active' : ''}`}
          onClick={() => onToolSelect(tool.id)}
          aria-label={tool.label}
          title={tool.label}
        >
          {tool.icon}
        </button>
      ))}
    </div>
  );
};

export default Toolbar;